import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ConfigurationApiContext } from "../context/ConfigurationApiContext";
import { EcsMetaContext } from "../context/EcsMetaContext";
import { createConfigurationApi } from "../helpers/createConfigurationApi";
// import { EcsReactStateProvider as EcsStateProvider } from "./EcsReactStateProvider";
import { ConfigurationStateProvider as EcsStateProvider } from "./ConfigurationStateProvider";
/**
 * This handles state updates
 * @category Controller
 * @param props
 */
export function ConfigurationController(props) {
    const { baseUrl, apiKey, children } = props, optionalProps = __rest(props, ["baseUrl", "apiKey", "children"]);
    const cfgApi = useMemo(() => {
        // use provided api
        if (optionalProps.cfgApi) {
            return optionalProps.cfgApi;
        }
        // else use default api
        const parameters = {};
        if (baseUrl) {
            parameters.basePath = baseUrl;
        }
        if (apiKey && typeof apiKey === "string") {
            if (/^basic|bearer/i.test(apiKey)) {
                // apiKey property does not work
                parameters.headers = { authorization: apiKey };
            }
        }
        return createConfigurationApi({
            basePath: baseUrl,
            apiKey: apiKey,
        });
    }, [baseUrl, apiKey, optionalProps.cfgApi]);
    const ecsMeta = useMemo(() => {
        return { baseUrl, apiKey };
    }, [baseUrl, apiKey]);
    return (_jsx(ConfigurationApiContext.Provider, { value: cfgApi, children: _jsx(EcsMetaContext.Provider, { value: ecsMeta, children: _jsx(EcsStateProvider, { children: children }) }) }));
}
//# sourceMappingURL=ConfigurationController.js.map